import * as xlsxLib from "sheetjs-style";
import { generateColumnValidations } from "./validation";

const convertFileDataToWbs = data => isBinaryString => {
  if (!isBinaryString) {
    data = new Uint8Array(data);
  }

  return xlsxLib.read(data, { type: isBinaryString ? "binary" : "array" });
};

const readXlsxFile = file => {
  return new Promise((res, _) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = e => {
      let data = e.target.result;
      res(convertFileDataToWbs(data)(rABS));
    };

    reader.onerror = function() {
      message.error(`Error while reading file: ${file.name}`);
      res();
    };

    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  });
};

const convertWbsToJsonArray = wbs => {
  return xlsxLib.utils.sheet_to_json(wbs).filter(record =>
    Object.values(record)
      .map((fieldValue, index) => {
        return index === 0 ? fieldValue.toString() : fieldValue;
      })
      .some(fieldValue => {
        return !!fieldValue.length;
      })
  );
};

const getSheetsObjectFrom = wbs => {
  return Object.entries(wbs.Sheets).reduce((sheets, [sheetName, wbsRows]) => {
    const sheetData = convertWbsToJsonArray(wbsRows);
    sheets[sheetName] = {
      data: sheetData,
      colValidations: generateColumnValidations(sheetName, sheetData)
    };

    return sheets;
  }, {});
};

export { readXlsxFile, convertWbsToJsonArray, getSheetsObjectFrom };
